import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import getProccesualDemandsRepository, { ServiceResponse } from './getProcessualDemands.repository';

type InitialState = {
  loading: boolean;
  data?: ServiceResponse[];
  error?: ErrorDto;
};

const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getProcessualDemands = createAsyncThunk('getProcessualDemands', async (): Promise<ServiceResponse[]> => {
  return await getProccesualDemandsRepository().catch((error:any) => {
    throw error;
  });
});

const serviceSlice = createSlice({
  name: 'getProcessualDemands',
  initialState,
  reducers: {
    servicesReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProcessualDemands.pending, (state) => {
      state.loading = true;
      state.data = [];
      state.error = undefined;
    });
    builder.addCase(
        getProcessualDemands.fulfilled,
      (state, action: PayloadAction<ServiceResponse[]>) => {
        state.loading = false;
        state.data = action.payload;
      },
    );
    builder.addCase(getProcessualDemands.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default serviceSlice.reducer;
export const { servicesReset } = serviceSlice.actions;
